import classnames from "classnames";
import PropTypes from "prop-types";

const Item = ({
  label = "",
  description = "",
  active = false,
  className = "",
  ...otherProps
}) => (
  <button
    type="button"
    className={classnames(
      "hover:bg-accent focus:bg-accent active:bg-accent mb-2 w-full cursor-pointer rounded-md border border-transparent p-3 text-start transition-all focus:outline-none motion-reduce:transition-none max-lg:p-2.5 max-md:p-2",
      {
        "border-border bg-background text-foreground hover:bg-background focus:bg-background active:bg-background shadow-sm":
          active,
        [className]: className,
      }
    )}
    {...otherProps}
  >
    <h5 className="text-sm font-semibold">{label}</h5>
    <p className="text-muted-foreground text-xs">{description}</p>
  </button>
);

Item.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
  active: PropTypes.bool,
  className: PropTypes.string,
};

export default Item;
